import isUndefined from "lodash/fp/isUndefined";
import camelCase from "lodash/fp/camelCase";
import random from "lodash/fp/random";
import multiply from "lodash/fp/multiply";
import isNil from "lodash/fp/isNil";
import isEqual from "lodash/fp/isEqual";
import omit from "lodash/fp/omit";
import functions from "lodash/fp/functions";
import isString from "lodash/fp/isString";

const getRandomId = () => multiply(random(0, 5000000), random(0, 5000000));

const eventsType = {
  onPaginate: "Pagination:paginate",
  onFilter: "Filter:filter:",
  onNavigate: "Navigation:navigate",
  onOpenSidenav: "Open:openSidenav",
  onListChange: "Edit:listChange",
  onAddItem: "Add:newItem",
  onShowNotification: "Show:notification",
  onUpdateItem: "Update:updateItem",

  onUpdateRoute: "Update:updateRoute",
  onUpdateCustomer: "Update:updateCustomer",
  onUpdateBooking: "Update:updateBooking",
  onUpdateBustype: "Update:updateBustype",
  onUpdateRide: "Update:updateRide",
  onRouteShedule: "Update:updateRouteSchedule",
  onUpdateTag: "Update:updateTag",
  onScheduleSave: "Save:saveSchedule",
  onCaptainUpdate: "Update:updateCaptain",
  onVendorUpdate: "Update:updateVendor",
  onAddStationRoute: "Add:addStation",
  onAddScheduleRoute: "Add:addSchedule",
  onUpdateCityDetail: "Update:updateCityDetail",
  onUpdateStationLoc: "Update:updateStationLoc",
  onShowErrorNotification: "ShowError:error",
  onShowSuccessNotification: "ShowSuccess:success",
  onReflectError: "Error:reflectRide",
  onRequestFileUrlEvent: "Request:fileUrl",
};

class Events {
  constructor() {
    "ngInject";

    this.events = {};
    this.eventsType = eventsType;
  }
  checkAndCreate(eventName) {
    const eventNotFound = isUndefined(this.events[eventName]);
    if (eventNotFound) {
      this.events[eventName] = {
        listeners: [],
      };
    }
  }
  checkEventName(eventName) {
    return isString(eventName);
  }
  emit(eventName, data) {
    if (this.checkEventName(eventName)) {
      this.checkAndCreate(eventName);
      this.events[eventName].listeners.forEach((listener) => listener(data));
    }
  }
  eventsHaveListeners(eventsList) {
    const status = [];
    eventsList.forEach((event) => {
      if (this.events[event] && this.events[event].listeners) {
        status.push(true);
      } else status.push(false);
    });
    return status;
  }
  on(eventName, cb) {
    if (this.checkEventName(eventName)) {
      this.checkAndCreate(eventName);
      this.events[eventName].listeners.push(cb);
    }
  }

  onAll(eventsList, cb) {
    eventsList.forEach((event) => {
      if (this.checkEventName(event)) {
        this.checkAndCreate(event);
        this.events[event].listeners.push(cb);
      }
    });
  }

  off(eventName, cb) {
    if (!isNil(this.events[eventName])) {
      const methodIndex = this.events[eventName].listeners.findIndex((a) => {
        return isEqual(omit(functions(a), a), omit(functions(cb), cb));
      });
      if (methodIndex > -1) {
        this.events[eventName].listeners.splice(methodIndex, 1);
      }
      const listenersLength = this.events[eventName].listeners.length;
      if (!listenersLength) delete this.events[eventName];
    }
  }

  getAddEvent(name) {
    return camelCase(`Add:add${name}${getRandomId()}`);
  }

  getDeleteEvent(name) {
    return camelCase(`Delete:delete${name}${getRandomId()}`);
  }

  getUpdateEvent(name) {
    return camelCase(`Update:update${name}${getRandomId()}`);
  }

  getFilterEvent(name) {
    return camelCase(`Filter:filter${name}${getRandomId()}`);
  }

  getNavigateEvent(name) {
    return camelCase(`Navigate:navigate${name}${getRandomId()}`);
  }

  getErrorEvent(name) {
    return camelCase(`Error:error${name}${getRandomId()}`);
  }

  getPaginateEvent(name) {
    return camelCase(`Paginate:paginate${name}${getRandomId()}`);
  }

  getActivitiesEvent(name) {
    return camelCase(`ShowActivities:ShowActivities${name}${getRandomId()}`);
  }

  getSortEvent(name) {
    return camelCase(`Sort:sort${name}${getRandomId()}`);
  }

  getRideLocationEvent(ride) {
    return camelCase(`Location:change${ride}`);
  }

  getCaptianLocationEvent(captain) {
    return camelCase(`Location:change${captain}`);
  }

  getSelectUserEvent() {
    return camelCase(`Select:user${getRandomId()}`);
  }

  getSelectBusEvent() {
    return camelCase(`Select:bustype${getRandomId()}`);
  }

  getSelectStartPointEvent() {
    return camelCase(`Select:startPoint${getRandomId()}`);
  }

  getSelectCorporateEvent() {
    return camelCase(`Select:corporate${getRandomId()}`);
  }
  getSelectCityEvent() {
    return camelCase(`Select:city${getRandomId()}`);
  }

  getSelectDestinationEvent() {
    return camelCase(`Select:destination${getRandomId()}`);
  }

  getSelectRouteEvent() {
    return camelCase(`Select:route${getRandomId()}`);
  }

  getSelectRideCategoryEvent() {
    return camelCase(`Select:rideCategory${getRandomId()}`);
  }

  getSelectSupplyCategoryEvent() {
    return camelCase(`Select:supplyCategory${getRandomId()}`);
  }

  getSelectContractorEvent() {
    return camelCase(`Select:contractor${getRandomId()}`);
  }

  getSelectCompanyEvent() {
    return camelCase(`Select:company${getRandomId()}`);
  }
  getSelectCityLanguageEvent() {
    return camelCase(`Select:cityLanguage${getRandomId()}`);
  }

  successUpdateEvent(name) {
    return camelCase(`Success:update${name}${getRandomId()}`);
  }
  startWatchEvent(name) {
    return camelCase(`Start:watch${name}${getRandomId()}`);
  }
  stopWatchEvent(name) {
    return camelCase(`Stop:watch${name}${getRandomId()}`);
  }
  clearWatchEvent(name) {
    return camelCase(`Clear:watch${name}${getRandomId()}`);
  }
  resumeWatchEvent(name) {
    return camelCase(`Resume:watch${name}${getRandomId()}`);
  }
  endCallEvent(name) {
    return camelCase(`End:call${name}${getRandomId()}`);
  }
  resetPasswordEvent(name) {
    return camelCase(`Reset:password${name}${getRandomId()}`);
  }
  editLookerEvent(name) {
    return camelCase(`Edit:Looker${name}${getRandomId()}`);
  }
  removeAdminEvent(name) {
    return camelCase(`Remove:${name}${getRandomId()}`);
  }
  openOfficeLocation(name) {
    return camelCase(`Open:${name}${getRandomId()}`);
  }
  removeOfficeLocation(name) {
    return camelCase(`Remove:${name}${getRandomId()}`);
  }
  viewOfficeLocationEvent(name) {
    return camelCase(`View:${name}${getRandomId()}`);
  }
  updateOfficeLocationEvent(name) {
    return camelCase(`Update:${name}${getRandomId()}`);
  }
  removeShift(name) {
    return camelCase(`Remove:${name}${getRandomId()}`);
  }
  setDefaultLocation(name) {
    return camelCase(`Set default:${name}${getRandomId()}`);
  }
  changeOfficeLocationStatus(name) {
    return camelCase(`Change status:${name}${getRandomId()}`);
  }
  changeShiftStatus(name) {
    return camelCase(`Change status:${name}${getRandomId()}`);
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/services/events/events.service.js